import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { PdpSharedDescriptionContent } from './PdpSharedDescriptionContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

export const Title = () => (
    <FormattedMessage
        id="PdpSharedDescriptionAdditionalOptions.customizationHeader"
        defaultMessage="Additional Options"
    />
);
export const Content = ({ customizationOptions, contentClass, buttonClass }) => (
    <PdpSharedDescriptionContent
        collapsedHeight={120}
        buttonClass={classNames(styles.button, buttonClass)}
    >
        <span className={classNames(styles.content, contentClass)}>{customizationOptions}</span>
    </PdpSharedDescriptionContent>
);

Content.propTypes = {
    customizationOptions: PropTypes.string,
    contentClass: PropTypes.string,
    buttonClass: PropTypes.string,
};

function PdpSharedDescriptionAdditionalOptionsComponent(props) {
    const { headerClass, contentClass, wrapperClass, item } = props;
    const { isCustomizable } = item;
    const customizationOptions = get(item, 'attributes.customizable[0].text');

    if (!isCustomizable || !customizationOptions) {
        return null;
    }

    return (
        <div
            data-tn="pdp-item-description-customization-options"
            className={classNames(styles.wrapper, wrapperClass)}
        >
            <h2 className={classNames(styles.header, headerClass)}>
                <Title />
            </h2>
            <Content customizationOptions={customizationOptions} contentClass={contentClass} />
        </div>
    );
}

PdpSharedDescriptionAdditionalOptionsComponent.propTypes = {
    wrapperClass: PropTypes.string,
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAdditionalOptions = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_item on Item {
                isCustomizable
                attributes {
                    customizable {
                        text
                    }
                }
            }
        `,
    }
);
